import { SVG, Path } from '@wordpress/primitives';

const productsIcon = (
    <SVG
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
    >
        <Path d="M21.5,3.75L21.5,20.25C21.5,20.664 21.164,21 20.75,21L3.25,21C2.836,21 2.5,20.664 2.5,20.25L2.5,3.75C2.5,3.336 2.836,3 3.25,3L20.75,3C21.164,3 21.5,3.336 21.5,3.75ZM20,4.5L4,4.5L4,19.5L20,19.5L20,4.5Z"/>
        <Path d="M13.437,3.915C13.438,3.501 13.774,3.165 14.188,3.165C14.601,3.165 14.938,3.501 14.937,3.915L14.937,11.67C14.938,11.968 14.76,12.239 14.487,12.358C14.213,12.477 13.895,12.422 13.676,12.219C13.676,12.219 11.708,10.385 11.708,10.385L9.74,12.219C9.522,12.422 9.204,12.477 8.93,12.358C8.656,12.239 8.479,11.968 8.479,11.67L8.479,3.915C8.479,3.501 8.815,3.165 9.229,3.165C9.643,3.165 9.979,3.501 9.979,3.915L9.979,9.946L11.197,8.811C11.485,8.543 11.932,8.543 12.22,8.811C12.22,8.811 13.438,9.946 13.437,9.946L13.437,3.915Z"/>
        <Path d="M6.604,17.7C6.19,17.7 5.854,17.364 5.854,16.95C5.854,16.536 6.19,16.2 6.604,16.2L11.125,16.2C11.539,16.2 11.875,16.536 11.875,16.95C11.875,17.364 11.539,17.7 11.125,17.7L6.604,17.7Z"/>
    </SVG>
);


export default productsIcon;